import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Table, Dropdown, Icon, Popup, Loader, Dimmer } from "semantic-ui-react";
import ScoreModal from "./ScoreModal";
import ConfirmCancelFromRoster from "./ConfirmCancelFromRoster"; // Corrected import path
import ResignContainer from "../containers/ResignContainer";
const popupTrigger = (
  <span>
    <Icon name="cog"></Icon>
  </span>
);

const RosterTableEsign = props => {

  const { t, i18n } = useTranslation();
  const dir = i18n.dir() === "rtl" ? "rtl" : "ltr";
  const textAlign = dir==="rtl" ? "right" : "left";
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (props.enrolledLearners !== undefined) {
      setLoading(false);
    }
  }, [props.enrolledLearners]);

  return (
    <>
      <Table unstackable={true} style={{ textAlign: textAlign}} compact>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              {t("manageRoster.rosterScreen.table.headers.name")}
            </Table.HeaderCell>
            <Table.HeaderCell className="computer only">
              {t("manageRoster.rosterScreen.table.headers.id")}
            </Table.HeaderCell>

            <Table.HeaderCell>
              {t("manageRoster.rosterScreen.table.headers.storeNumber")}
            </Table.HeaderCell>

            <Table.HeaderCell>
              {t("manageRoster.rosterScreen.table.headers.score")}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t("manageRoster.rosterScreen.table.headers.learnerSignature")}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t("manageRoster.rosterScreen.table.headers.instructorSignature")}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t("manageRoster.rosterScreen.table.headers.edit")}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        {loading ? (
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan={7} textAlign="center" style={{padding: '20px'}}>
                <Dimmer active inverted>
                  <Loader size="large"></Loader>
                </Dimmer>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        ) : (
          props.enrolledLearners && props.enrolledLearners.length > 0 ? (
            <Table.Body>
              {props.enrolledLearners.map(learner => (
                <Table.Row key={learner.userId}>
                  {learner.error ? (
                    <Popup
                      content={learner.errorMessage}
                      trigger={
                        <Table.Cell style={{ color: "red" }}>
                          {learner.firstName + " " + learner.lastName}
                          <Icon color="red" name="exclamation circle" />
                        </Table.Cell>
                      }
                    />
                  ) : (
                    <Table.Cell>
                      {learner.firstName + " " + learner.lastName}
                    </Table.Cell>
                  )}
                  <Table.Cell className="computer only">
                    {learner.learnerNum}
                  </Table.Cell>
                  <Table.Cell>{learner.storeNSN}</Table.Cell>
                  <Table.Cell>
                    {learner.score !== 0 ? (
                      learner.score
                    ) : (
                      <Icon color="black" name="minus" size="small"></Icon>
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    {learner.signature !== "" ? (
                      <Icon name="check" color="green"></Icon>
                    ) : (
                      <Icon color="red" name="minus" size="small"></Icon>
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    {learner.complete ? (
                      <Icon name="check" color="green"></Icon>
                    ) : (
                      <Icon color="red" name="minus" size="small"></Icon>
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    {learner.complete ? (
                      <Popup style={{textAlign}}
                        content={t("manageRoster.rosterScreen.table.icons.hints.learnerIsAlreadyComplete")}
                        on="click"
                        trigger={<Icon color="grey" name="cog"></Icon>}
                      />
                    ) : (
                      <Dropdown
                        trigger={popupTrigger}
                        pointing="top right"
                        icon={null}
                      >
                        <Dropdown.Menu>
                          <ScoreModal
                            setUpdateTable={props.setUpdateTable}
                            learner={learner}
                          ></ScoreModal>
                          <ConfirmCancelFromRoster
                            handleCancelLearner={props.handleCancelLearner}
                            person={learner}
                          ></ConfirmCancelFromRoster>
                          {learner.signature !== "" ? (
                            <ResignContainer
                              submitSignatures={props.submitSignatures}
                              handleCancelLearner={props.handleCancelLearner}
                              setAllSignedOff={props.setAllSignedOff}
                              setUpdateTable={props.setUpdateTable}
                              enrolledLearners={props.enrolledLearners}
                              resign={true}
                              learner={learner}
                            ></ResignContainer>
                          ) : (
                            <></>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          ) : (
            <Table.Body>
              <Table.Row>
                <Table.Cell colSpan={7} textAlign="center">
                  {t("manageRoster.rosterScreen.table.noLearnersFound", "No learners enrolled.")}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          )
        )}
      </Table>
    </>
  );
};
export default RosterTableEsign;
